if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer
          ? this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`)
          : null;

        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

if (!customElements.get('media-gallery-swiper')) {
  customElements.define(
    'media-gallery-swiper',
    class MediaGallerySwiper extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          swiper: this.querySelector('.slider-mobile-gutter--custom .swiper'),
        };

        this.initSwiper();
        this.calculateMobileGalleryWrapper();
        let self = this;
        let resizeTimeout;
        this.calculateTop();
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimeout);
          self.calculateTop();
          resizeTimeout = setTimeout(self.calculateMobileGalleryWrapper(), 250);
        });

        // let variantSelectors = document.querySelectorAll('.variant-option-button');
        // variantSelectors.addEventListener('click', () => {
        //   setTimeout(this.calculateTop(), 1000);
        // });
        const observer = new MutationObserver(() => {
          this.calculateTop();
        });

        observer.observe(document.querySelector('.swiper-media-gallery'), {
          subtree: true,
          childList: true,
        });
        this.imageUrls = [];
        this.currentIndex = 0;
        setTimeout(() => {
          this.initLightbox();
        },500)
      }

      initSwiper() {
        const swiperOptions = {
          direction: 'vertical',
          loop: false,
          slidesPerView: 'auto',
          speed: 500,
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
            thresholdDelta: 40,
            thresholdTime: 200
          },
          scrollbar: {
            el: this.querySelector('.swiper-scrollbar'),
            draggable: true,
          },
          touchReleaseOnEdges: true, 
          breakpoints: {
            750: {
              scrollbar: {
                dragSize: 183,
              },
            },
          },
          touchRatio: 1,
          freeMode: false,
          speed: 400,
          on: {
            slideChangeTransitionEnd: function () {
              document.querySelectorAll('.swiper-slide video').forEach((v) => {
                v.pause();
              });

              const activeSlide = this.slides[this.activeIndex];
              const video = activeSlide.querySelector('video');
              if (video) {
                video.play();
              }
            },
          }
        };
        
        const swiper = new Swiper(this.elements.swiper, swiperOptions);
      }

      calculateTop() {
        this.querySelectorAll('.media-extend-item').forEach((item) => {
          let position = Number(item.getAttribute('data-position'));
          let marginBottom = 8;
          if (window.screen.width >= 750) {
            marginBottom = 40;
          }
          let heightPlus = (position - 1) * marginBottom;
          item.classList.remove('hidden');
          let heightItem = Number(item.offsetHeight);
          let heightMediaMain = Number(this.querySelector('.swiper-wrapper').querySelector('li').offsetHeight);
          if (heightMediaMain == 0) {
            heightMediaMain = 700;
          }
          let top = heightMediaMain * position + heightPlus - heightItem;
          item.style.top = top + 'px';
        });
      }

      calculateMobileGalleryWrapper() {
        const sliderWrapper = this.querySelector('.swiper');

        if (window.innerWidth < 750) {
          const firstGalleryItem = this.querySelectorAll('.product__media-item')[0];

          if (firstGalleryItem && sliderWrapper) {
            sliderWrapper.style.maxHeight = `${firstGalleryItem.clientHeight}px`;
          }
        } else {
          sliderWrapper.style.maxHeight = null;
        }
      }
      initLightbox() {
        // const images = this.querySelectorAll('.media__trigger');

        // if (!images) return;

        // const lightboxHtml = `
        //   <div id="rocket-lightbox-modal" class="rocket-lightbox-modal">
        //     <span class="lightbox-close">
        //       <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        //         <line x1="1.35355" y1="0.646447" x2="19.3536" y2="18.6464" stroke="white"/>
        //         <line x1="0.646447" y1="18.6464" x2="18.6464" y2="0.646445" stroke="white"/>
        //       </svg>
        //     </span>
        //     <div class="lightbox-inner">
        //       <img class="lightbox-content" />
        //       <div class="lightbox-control">
        //         <div class="lightbox-prev">
        //             <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        //               <path d="M13 19.834L1 10.5007L13 1.16732" stroke="white"/>
        //             </svg>
        //           </div>
        //         <div class="lightbox-next">
        //           <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        //             <path d="M1 0.5L13 9.5L1 18.5" stroke="white"/>
        //           </svg>
        //         </div>
        //       </div>
        //     </div>
        //   </div>
        // `;
        // document.body.insertAdjacentHTML('beforeend', lightboxHtml);
      }
    }
  );
}